<template>
  <!-- don't forget change viewBox and fill params -->
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6667 3.33317C11.6667 4.24984 10.9167 4.99984 10.0001 4.99984C9.0834 4.99984 8.3334 4.24984 8.3334 3.33317C8.3334 2.4165 9.0834 1.6665 10.0001 1.6665C10.9167 1.6665 11.6667 2.4165 11.6667 3.33317ZM16.2584 5.19984C16.7167 5.09984 17.1751 5.3665 17.2917 5.82484C17.4084 6.2915 17.1251 6.7665 16.6584 6.87484C15.3251 7.17484 13.8751 7.38317 12.5001 7.49984V17.4998C12.5001 17.9582 12.1251 18.3332 11.6667 18.3332C11.2084 18.3332 10.8334 17.9582 10.8334 17.4998V13.3332H9.16673V17.4998C9.16673 17.9582 8.79173 18.3332 8.33339 18.3332C7.87506 18.3332 7.50006 17.9582 7.50006 17.4998V7.49984C6.12506 7.38317 4.67506 7.17484 3.33339 6.87484C2.87506 6.7665 2.59173 6.2915 2.70839 5.82484C2.82506 5.3665 3.28339 5.09984 3.74173 5.19984C5.72506 5.6415 7.93339 5.83317 10.0001 5.83317C12.0667 5.83317 14.2751 5.6415 16.2584 5.19984Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
